// @generated by protoc-gen-es v2.10.1 with parameter "target=ts"
// @generated from file bfftypes/v1/area.proto (package bfftypes.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc } from "@bufbuild/protobuf/codegenv2";

/**
 * Describes the file bfftypes/v1/area.proto.
 */
export const file_bfftypes_v1_area: GenFile = /*@__PURE__*/
  fileDesc("ChZiZmZ0eXBlcy92MS9hcmVhLnByb3RvEgtiZmZ0eXBlcy52MSqGAgoIQXJlYUNvZGUSGQoVQVJFQV9DT0RFX1VOU1BFQ0lGSUVEEAASFgoSQVJFQV9DT0RFX0hPS0tBSURPEAESFAoQQVJFQV9DT0RFX1RPSE9LVRACEhMKD0FSRUFfQ09ERV9UT0tZTxADEhMKD0FSRUFfQ09ERV9DSFVCVRAEEhYKEkFSRUFfQ09ERV9IT0tVUklLVRAFEhQKEEFSRUFfQ09ERV9LQU5TQUkQBhIVChFBUkVBX0NPREVfQ0hVR09LVRAHEhUKEUFSRUFfQ09ERV9TSElLT0tVEAgSFAoQQVJFQV9DT0RFX0tZVVNIVRAJEhUKEUFSRUFfQ09ERV9PS0lOQVdBEApCQlpAZ2l0aHViLmNvbS9lbmVjaGFpbi9lYmFsYW5jZS9nby9nZW4vcHJvdG8vYmZmdHlwZXMvdjE7YmZmdHlwZXN2MWIGcHJvdG8z");

/**
 * AreaCode identifies one of the ten Japanese electricity supply
 * regions. Hosted under bfftypes/v1 because the enum is reused across
 * multiple BFF service packages (= bffuser.v1 demand / generation /
 * occto-master, future admin services).
 *
 * Wire values mirror backend types.v1.AreaCode but the enum is kept
 * BFF-local so that BFF's contract with the frontend stays decoupled
 * from backend internal types.
 *
 * @generated from enum bfftypes.v1.AreaCode
 */
export enum AreaCode {
  /**
   * @generated from enum value: AREA_CODE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: AREA_CODE_HOKKAIDO = 1;
   */
  HOKKAIDO = 1,

  /**
   * @generated from enum value: AREA_CODE_TOHOKU = 2;
   */
  TOHOKU = 2,

  /**
   * @generated from enum value: AREA_CODE_TOKYO = 3;
   */
  TOKYO = 3,

  /**
   * @generated from enum value: AREA_CODE_CHUBU = 4;
   */
  CHUBU = 4,

  /**
   * @generated from enum value: AREA_CODE_HOKURIKU = 5;
   */
  HOKURIKU = 5,

  /**
   * @generated from enum value: AREA_CODE_KANSAI = 6;
   */
  KANSAI = 6,

  /**
   * @generated from enum value: AREA_CODE_CHUGOKU = 7;
   */
  CHUGOKU = 7,

  /**
   * @generated from enum value: AREA_CODE_SHIKOKU = 8;
   */
  SHIKOKU = 8,

  /**
   * @generated from enum value: AREA_CODE_KYUSHU = 9;
   */
  KYUSHU = 9,

  /**
   * @generated from enum value: AREA_CODE_OKINAWA = 10;
   */
  OKINAWA = 10,
}

/**
 * Describes the enum bfftypes.v1.AreaCode.
 */
export const AreaCodeSchema: GenEnum<AreaCode> = /*@__PURE__*/
  enumDesc(file_bfftypes_v1_area, 0);

